import $ from 'jquery';
import { debounce } from '../utils/functions';

const $window = $(window);
const $item = $('.link-icon-item');

$(function () {
    constrainCards();
    $window.on('resize:width', debounce(freeCards, true));
    $window.on('resize:width', debounce(constrainCards, false, 200));

    $item.on('mouseenter', scrollUp);
    $item.on('mouseleave', scrollDown);
});

function scrollUp() {
    const $thisEl = $(this);
    $thisEl.find('.link-icon-item__card.content').show(0, function () {
        $thisEl.stop().animate({ scrollTop: $thisEl.outerHeight() }, 500);
    });
}
function scrollDown() {
    const $thisEl = $(this);
    $thisEl.stop().animate({ scrollTop: 0 }, 500, function () {
        $thisEl.find('.link-icon-item__card.content').hide();
    });
}

const freeCards = () =>
    $item.each(function () {
        const $thisEl = $(this);
        $thisEl.find('.link-icon-item__card').removeAttr('style');
        $thisEl.find('.link-icon-item__card.content').hide(0, function () {
            $thisEl.removeAttr('style').css('pointer-events', 'none');
        });
    });

const constrainCards = () =>
    $item.each(function () {
        const $thisEl = $(this);
        const height = $thisEl.outerHeight();
        $thisEl
            .removeAttr('style')
            .css('max-height', height)
            .find('.link-icon-item__card')
            .css('min-height', height);
    });
